export const AwardType = {
  GOOD_BEER: 'GOOD_BEER',
  BETTER_BEER: 'BETTER_BEER',
  DOUBLE_BEER: 'DOUBLE_BEER',
  ICE: 'ICE'
}

export const AUTH_STORAGE_TOKEN = 'EGBR_STORAGE_TOKEN'
